<template>
    <div id="userData" v-loading="loading">
        <div>
            <div v-if="loading" class="loadingAlert">
                <el-alert
                    title="加载中"
                    description="正在加载数据,这可能需要一些时间,请稍后..."
                    type="warning"
                    center
                    show-icon
                    :closable="false">
                </el-alert>
            </div>
            <div :class="$root.isMob() ? 'contentInfo mob' : 'contentInfo'">
                <div class="infoTitle">
                    <div class="text">
                        <i class="el-icon-s-tools icon"></i><h3>工具</h3>
                    </div>                    
                </div>
                <div class="buttonGroup">
                    <el-button class="toolsButton" type="primary" @click="link(APIUrl+'/uploads/20250116/d2a2c2689665d33e40f51b60f339e16f.pdf')">平台操作手册</el-button>
                    <el-button class="toolsButton" type="primary" @click="link(APIUrl+'/uploads/20250117/95444ff7b63f8b585860ebc03cb78b54.pdf')">通用数智项目操作手册</el-button>
                </div>                
            </div>
            <div :class="$root.isMob() ? 'contentInfo mob' : 'contentInfo'" style="padding-bottom: 0;">
                <div class="infoTitle">
                    <div class="text">
                        <i class="el-icon-s-marketing icon"></i><h3>我的统计</h3>
                    </div>                    
                </div>
                <div class="title">
                    <div class="info">
                        <div class="avatar">
                            <img :src="API + userInfo.avatar" alt="">
                        </div>
                        <div class="text">
                            <h1>HI~ {{userInfo.name}}</h1>
                        </div> 
                    </div>                    
                    <div class="data">          
                        <div class="item">
                            <div class="num"><h3>{{ unityNum }}</h3></div>
                            <div class="text"><h3>实训考核次数</h3></div>
                        </div>          
                        <div class="item">
                            <div class="num"><h3>{{ unityTestNum || 0 }}</h3></div>
                            <div class="text"><h3>实训练习次数</h3></div>
                        </div>          
                        <div class="item">
                            <div class="num"><h3>{{ testsNum }}</h3></div>
                            <div class="text"><h3>理论考核次数</h3></div>
                        </div>  
                        <div class="item">
                            <div class="num"><h3>{{ practicNum }}</h3></div>
                            <div class="text"><h3>理论练习次数</h3></div>
                        </div>  
                        <div class="item">
                            <div class="num"><h3>{{ unityPower }}</h3></div>
                            <el-tooltip placement="bottom">
                                <div class="text"><h3>实操能力评级</h3></div>
                                <div slot="content">
                                    取最近1000条实操数据的总得分 / 满分的占比进行评级<br>
                                    80分以上为A 60分以上为B 60分以下为C
                                </div>
                            </el-tooltip>
                        </div>  
                        <div class="item">
                            <div class="num"><h3>{{ testsPower }}</h3></div>
                            <el-tooltip placement="bottom">
                                <div class="text"><h3>理论能力评级</h3></div>
                                <div slot="content">
                                    取最近1000条理论考核数据的总得分 / 满分的占比进行评级<br>
                                    80分以上为A 60分以上为B 60分以下为C
                                </div>
                            </el-tooltip>
                        </div>  
                    </div>     
                    <div class="img" v-if="!loading && !$root.isMob()">
                        <img :src="Computer" alt="">
                    </div>      
                </div>
            </div>
            <div :class="$root.isMob() ? 'contentInfo mob' : 'contentInfo'">
                <div class="infoTitle">
                    <div class="text">
                        <i class="el-icon-s-custom icon"></i><h3>用户信息</h3>
                    </div>                    
                </div>
                <el-descriptions :direction="$root.isMob() ? 'vertical': ''" :column="$root.isMob() ? 2 : 3" :border="$root.isMob() ? true : false">
                    <el-descriptions-item label="姓名">{{userInfo.name}}</el-descriptions-item>
                    <el-descriptions-item label="Email">{{userInfo.email}}</el-descriptions-item>
                    <el-descriptions-item label="手机号">{{ userInfo.mobile }}</el-descriptions-item>
                    <el-descriptions-item v-if="!isshow" label="我的单位">{{ userInfo.company }}</el-descriptions-item>
                    <el-descriptions-item v-if="userInfo && userInfo.lab && userInfo.lab.name" label="我的单位">{{ userInfo.lab.name}}
                        <span class="lab_status" >({{userInfo.lab.status}})</span></el-descriptions-item>
                    <el-descriptions-item v-if="userInfo && userInfo.lab && userInfo.lab.name" label="学号">{{ userInfo.student_id }}</el-descriptions-item>
                </el-descriptions>
                <div class="buttonBox">
                    <el-button type="primary" @click="$emit('linkto','info')">修改</el-button>
                </div>                
            </div>
            <div :class="$root.isMob() ? 'contentInfo mob' : 'contentInfo'"  v-if="isshow === 0">
                <div class="infoTitle">
                    <div class="text">
                        <i class="el-icon-s-order icon"></i>
                        <h3>
                            近期记录
                        </h3>
                        <div class="reload" @click="getData()">
                            <i class="el-icon-refresh-right icon"></i>刷新
                        </div>
                    </div>
                    <div class="buttonBox">
                        <el-button type="primary" @click="$emit('linkto','practiceLog')">理论练习记录</el-button>
                        <el-button type="primary" @click="$emit('linkto','testsLog')">理论考核记录</el-button>
                        <el-button type="primary" @click="$emit('linkto','unityLog')">实训考核记录</el-button>
                        <el-button type="primary" @click="$emit('linkto','unityTestLog')">实训练习记录</el-button>
                    </div>                    
                </div>
                <el-table :data="logList" border style="width: 100%">
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="type" label="类型" width="150" v-if="!$root.isMob()">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.type == '理论考核'" style="width: 100%; text-align: center;" type="success">{{scope.row.type}}</el-tag>
                            <el-tag v-if="scope.row.type == '理论练习'" style="width: 100%; text-align: center;" type="warning">{{scope.row.type}}</el-tag>
                            <el-tag v-if="scope.row.type == '实操考核'" style="width: 100%; text-align: center;">{{scope.row.type}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createtime" label="日期" width="200" v-if="!$root.isMob()"></el-table-column>
                    <el-table-column prop="score" label="得分/评级" width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.score == 0 && scope.row.type == '实操考核'" class="noExamResult">
                                未完成
                            </div>
                            <div v-if="scope.row.score != 0 && scope.row.type == '实操考核'" class="examResult">
                                {{ scope.row.score }}
                            </div>    
                            <div v-if="scope.row.type == '理论考核' || scope.row.type == '理论练习'" class="examResult">
                                {{ scope.row.score }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>        
    </div>
</template>
<script>
import Computer from '@/assets/img/svg/Computer.svg'
export default{
    data(){
        return{
            Computer:Computer,
            userInfo:false,
            API:window.config.api,
            loading:true,
            logList:[],
            unityNum:0,
            unityTestNum:0,
            testsNum:0,
            practicNum:0,
            unityPower:"",
            testsPower:"",
            APIUrl:window.config.api,
            isshow:1,
        }
    },
    watch:{
    },
    methods:{
        async getData(){
            this.userInfo = await this.$root.getUserInfo();  
            this.isshow = this.userInfo.settled_unit_branch_id;       
            let testsData = await this.$root.getTestsLog(0,1,6);
            if(testsData.data){
                this.testsNum = testsData.total;
                testsData.data.forEach(item => {
                    item.createtime = this.$root.formatDate(item.createtime);
                    item.type = '理论考核';
                    item.score = item.exam_scores;                    
                });
                
                this.logList = testsData.data.slice(0,6);
            }
            
            let practiceData = await this.$root.getPracticeLog(1,6);
            if(practiceData.data){
                this.practicNum = practiceData.total;
                practiceData.data.forEach(item => {
                    item.name = "理论练习"
                    item.createtime = this.$root.formatDate(item.createtime);
                    item.type = '理论练习';
                    item.score = item.exam_scores;                 
                });
                
                this.logList = this.logList.concat(practiceData.data.slice(0,6));
            }
            
            let unityTestData = await this.$root.getUnityTestLog();
            this.unityTestNum = unityTestData.total;

            let unityData = await this.$root.getUnityLog(0,1,6);
            if(unityData.data){
                this.unityNum = unityData.total;
                unityData.data.forEach(item => {
                    item.createtime = this.$root.formatDate(item.starttime);
                    item.type = '实操考核';
                    item.score = item.exam_result;
                    item.name = item.dj_name;
                });
                this.logList = this.logList.concat(unityData.data.slice(0,6));
            }
            
            this.logList = this.logList.sort((a,b)=>{
                return new Date(b.createtime) - new Date(a.createtime);
            }).slice(0,6);
            
            let allUnityData = await this.$root.getUnityLog(0,1,1000);
            if(allUnityData.data){
                let totalScrore = 0;
                let resultScrore = 0;
                allUnityData.data.forEach(item => {
                    totalScrore = totalScrore + item.steps_scores;
                    resultScrore = resultScrore + item.exam_scores;
                });
                let allUnityScroe = (resultScrore / totalScrore) * 100;
                if(allUnityScroe >= 80){
                    this.unityPower = "A";
                }
                else if(allUnityScroe >= 60){
                    this.unityPower = "B";
                }
                else{
                    this.unityPower = "C";
                }
            }
            
            let allTestsData = await this.$root.getTestsLog(0,1,1000);
            if(allTestsData.data){
                let totalScrore = 0;
                let resultScrore = 0;
                allTestsData.data.forEach(item => {
                    totalScrore = totalScrore + item.tests_scores;
                    resultScrore = resultScrore + item.exam_scores;
                });
                let allTestsScroe = (resultScrore / totalScrore) * 100;
                if(allTestsScroe >= 80){
                    this.testsPower = "A";
                }
                else if(allTestsScroe >= 60){
                    this.testsPower = "B";
                }
                else{
                    this.testsPower = "C";
                }
            }
            this.loading = false;
        },
        link(url){
            window.open(url,"_blank");
        }
    },
    created(){
        this.getData();
    },
}
</script>
<style lang="scss" scoped src="@/assets/css/lib/userData.scss">
</style>